import ProgrammeForm from "@/components/formateur/ProgrammeForm";

export default function ProgrammeEditPage() {
    return (
        <div className="mx-auto max-w-6xl px-6 py-10" data-testid="page-programme-edit">
            <div className="mb-8">
                <div className="text-xs uppercase tracking-[0.25em] text-brand-orange">Mon programme</div>
                <h1 className="mt-3 font-display text-4xl font-normal tracking-tightest">
                    Trame de votre formation
                </h1>
                <p className="mt-2 max-w-2xl text-brand-smoke">
                    Modifiez librement votre programme. Chaque section est sauvegardée automatiquement.
                </p>
            </div>
            <ProgrammeForm mode="edit" />
        </div>
    );
}
